// // import insuranceType from "./general-insurence/insurance-type";
import { accordian } from "../../utils/accordian/accordian.js";
import talkExpert from "../components/talk-expert.js";
import ourProducts from "./Home/our-products.js";


// setTimeout(function (e) {
    talkExpert()
    accordian()
    ourProducts({modifier: 'height', toggle: 'data-show', content: 'data-product',img: 'data-product-img',})
// },2000)
